export enum StatusCancelamentoCompraEnum {
  Cancelado = 1,
  JaCancelado = 2,
  NaoEncontrado = 3,
  SemPermissaoNaEtapa = 4,
  MovimentacaoNaoPermitida = 5,
  /** Etapa Cancelado libera a NF, mas o lançamento da NF-e vinculada já foi gerado. */
  LancamentoGerado = 6,
}
